import React from "react";
import { Row, Col, Typography } from "antd";
import metaData from "../../data/metaData";
import Slider from "react-slick";
import { sliderSetting } from "../../css/css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const { Text } = Typography;

const GalleryDisplay = ({ gallery, width = "100%", dots = true, ...props }) => {
  const sliderSettings = {
    ...sliderSetting,
    dots,
  };

  return (
    <Row style={{ marginBottom: "2rem" }} {...props}>
      {gallery?.length > 0 ? (
        <div style={{ width }}>
          <Slider {...sliderSettings}>
            {gallery.map((url, i) => (
              <img
                key={i}
                src={`${metaData.blobPreURL}clientUpload-${url}.jpeg${metaData.blobPostURL}`}
                alt={`Gallery image ${i + 1}`}
              />
            ))}
          </Slider>
        </div>
      ) : (
        <Text>No gallery images available</Text>
      )}
    </Row>
  );
};

export default GalleryDisplay;
